































































































import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import Icon from '../common/Icon.vue';
import MainButton from '../common/MainButton.vue';
import ModalConfirm from '@/main-components/common/modal/ModalConfirm.vue';
import { DeleteResource, deleteResource } from '@/utils/delete-resource';
import { Collection } from '@/resource/collection/collection.model';
import ModalTwoButtons from '../common/modal/ModalTwoButtons.vue';

@Component({
  components: { MainButton, Icon, ModalConfirm, ModalTwoButtons },
})
export default class PaperOption extends Vue {
  @Inject('colorBrandDarkPrimary')
  colorBrandDarkPrimary!: string;

  @Inject('colorBlackPrimary')
  colorBlackPrimary!: string;

  @Inject('toggleShowRearrange')
  toggleShowRearrange!: (value: boolean) => void;

  @Inject('savePaperItemPositions')
  savePaperItemPositions!: () => Promise<void>;

  @Inject('addOrEditQuestion')
  addOrEditQuestion!: (isSubjective: boolean) => Promise<void>;

  @Inject('generatePdf')
  generatePdf!: () => Promise<void>;

  @Prop({ required: true })
  paper: Collection;

  @Prop({ default: false })
  showRearrange: boolean;

  @Prop({ default: 0 })
  totalPaperItems: number;

  @Prop({ required: true })
  openQuestionBankModal: () => void;

  get isDisableMainButtons() {
    return this.showRearrange;
  }

  openDeletePaperModal: any = null;
  openGeneratePDFModal: any = null;
  openTwoButtonsModal: any = null;

  paperOptions = [
    {
      name: 'Muat Turun Sebagai PDF',
      icon: 'ic_pdf',
      onClick: this.generatePdfClicked,
    },
    {
      name: 'Susun Semula Kedudukan',
      icon: 'ic_rearrange_arrow',
      onClick: this.rearrangePositionClicked,
    },
    {
      name: 'Padam Latihan',
      icon: 'ic_dustbin_v2',
      onClick: this.deletePaperClicked,
    },
  ];

  addMoreQuestionsClicked() {
    if (this.isDisableMainButtons) return;
    this.openQuestionBankModal && this.openQuestionBankModal();
  }

  createNewQuestionClicked() {
    if (this.isDisableMainButtons) return;
    this.$sendMpEvent({ event: this.$mp_value.PaperAddOwnQuestionClick });
    this.openTwoButtonsModal && this.openTwoButtonsModal();
  }

  generatePdfClicked() {
    if (this.isDisableMainButtons || !this.totalPaperItems) return;
    this.$sendMpEvent({ event: this.$mp_value.PaperGeneratePdfClick });
    this.openGeneratePDFModal && this.openGeneratePDFModal();
  }

  rearrangePositionClicked() {
    if (this.isDisableMainButtons || !this.totalPaperItems) return;
    this.$sendMpEvent({ event: this.$mp_value.PaperRearrangePositionClick });
    this.toggleShowRearrange(true);
  }

  cancelRearrangePositionClicked() {
    this.toggleShowRearrange(false);
  }

  doneRearrangePositionClicked() {
    this.savePaperItemPositions();
  }

  deletePaperClicked() {
    if (this.isDisableMainButtons) return;
    this.$sendMpEvent({ event: this.$mp_value.PaperDeleteClick });
    this.openDeletePaperModal && this.openDeletePaperModal();
  }

  async onDeletePaperSubmit() {
    if (this.isDisableMainButtons) return;
    await deleteResource(this.paper.uuid, DeleteResource.Collection);

    this.$router.push(`/papers`);
    this.$toasted.global.mainToast({
      message: 'Paper deleted',
    });
  }

  openDeletePaperModalAdd(openModal: any) {
    this.openDeletePaperModal = openModal;
  }

  openGeneratePDFModalAdd(openModal: any) {
    this.openGeneratePDFModal = openModal;
  }

  openTwoButtonsModalAdd(openModal: any) {
    this.openTwoButtonsModal = openModal;
  }

  openVideoTutorialModal() {
    this.$emit('openVideoTutorialModal');
  }
}
